import React from "react";
import { useLang } from "@/lib/i18n";
import { TrendingUp, Target, Users, BarChart3 } from "lucide-react";
import CountUp from "./CountUp";

function Card({ icon: Icon, children, label, testid, delay, gold }) {
  return (
    <div data-testid={testid} className="at-card rounded-2xl p-6 animate-fade-up" style={{ animationDelay: delay }}>
      <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ring-1 ${gold ? "text-[#38040C] ring-[var(--trust-gold)]" : "bg-white/8 text-[var(--trust-gold)] ring-[var(--border-gold)]"}`}
           style={gold ? { background: "linear-gradient(135deg,#FFE566,#FFD700)" } : {}}>
        <Icon size={20} />
      </div>
      <div className="font-serif-display font-bold text-4xl tracking-tight text-white">{children}</div>
      <div className="text-xs font-heading font-semibold uppercase tracking-wider text-white/60 mt-1.5">{label}</div>
    </div>
  );
}

export default function KeyStats({ stats, settings }) {
  const { t } = useLang();
  const total = settings.display_total_tips;
  const won = Math.round((total * settings.display_win_rate) / 100);
  const lost = total - won;

  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--at-deep)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          <Card testid="stat-won" icon={Target} label={t("stats.won")} delay="0.05s"><CountUp value={won} /></Card>
          <Card testid="stat-lost" icon={BarChart3} label={t("stats.lost")} delay="0.1s"><CountUp value={lost} /></Card>
          <Card testid="stat-avgodds" icon={TrendingUp} label={t("stats.avgOdds")} delay="0.15s"><CountUp value={stats.avg_odds} decimals={2} /></Card>
          <Card testid="stat-members" icon={Users} label={t("stats.members")} delay="0.2s" gold><CountUp value={settings.active_members / 1000} decimals={1} suffix="k" /></Card>
        </div>
      </div>
    </section>
  );
}
